import {
  fetchGetMobwebOnboardings,
  TGetMobwebOnboardingsResponse_1,
} from '../../repositories/mobile-app-onboarding/v1/get-mobweb-onboardings';
import { withTypeSafeApiResult } from '../../utils/typesafe-result';

/* istanbul ignore next */
export const fetchGetMobwebOnboardingsSafe =
  withTypeSafeApiResult<TGetMobwebOnboardingsResponse_1>(fetchGetMobwebOnboardings);
